import { render } from "./MainLang.vue?vue&type=template&id=4f68bf30"
import script from "./MainLang.vue?vue&type=script&lang=js"
export * from "./MainLang.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__